<app-configuration-page
  title="Permissions"
  description="Control who can do what within your studio. Select a role to view and edit its permissions."
  [breadcrumbs]="[{ label: 'Permissions' }]">

  <!-- Loading state -->
  <div *ngIf="loading" class="loading-state mt-4">
    <mat-spinner diameter="40"></mat-spinner>
    <span>Loading permissions&hellip;</span>
  </div>

  <div class="permissions-layout mt-4" [class.detail-open]="selectedRole" *ngIf="!loading">

    <!-- Left: Role selector -->
    <div class="role-list">
      <mat-card *ngFor="let role of roles"
           class="role-card"
           [class.role-card--active]="selectedRole?.id === role.id"
           (click)="selectRole(role)">
        <div class="role-card-body">
          <div class="role-card-icon">
            <mat-icon>{{ roleIcon(role) }}</mat-icon>
          </div>
          <div class="role-card-info">
            <span class="role-card-name">{{ role.label }}</span>
            <span class="role-card-desc" [matTooltip]="role.description">{{ role.description }}</span>
            <div class="role-card-meta">
              <span>{{ role.memberCount }} {{ role.memberCount === 1 ? 'member' : 'members' }}</span>
              <span class="meta-sep">&middot;</span>
              <span>{{ role.permissions.length }}/{{ permissions.length }} permissions</span>
            </div>
          </div>
          <mat-icon class="role-card-arrow">chevron_right</mat-icon>
        </div>
      </mat-card>
    </div>

    <!-- Right: Permission detail -->
    <div class="permission-panel" *ngIf="selectedRole">
      <mat-card class="permission-panel-card">
        <button mat-button class="mobile-back-btn" type="button" (click)="selectedRole = null">
          <mat-icon>arrow_back</mat-icon> All roles
        </button>
        <mat-card-header>
          <div mat-card-avatar class="panel-icon">
            <mat-icon>{{ roleIcon(selectedRole) }}</mat-icon>
          </div>
          <mat-card-title>{{ selectedRole.label }}</mat-card-title>
          <mat-card-subtitle>{{ selectedRole.description }}</mat-card-subtitle>
        </mat-card-header>

        <!-- Members chip list -->
        <div class="role-members" *ngIf="membersForRole(selectedRole).length > 0">
          <span class="members-label">Members:</span>
          <span class="member-chip" *ngFor="let m of membersForRole(selectedRole)">{{ m.name }}</span>
        </div>

        <mat-card-content>
          <div *ngFor="let category of permissionCategories" class="permission-category">
            <h3 class="category-heading">{{ category }}</h3>
            <div class="permission-list">
              <div *ngFor="let perm of permissionsForCategory(category)" class="permission-row">
                <mat-slide-toggle
                  [checked]="roleHasPermission(selectedRole, perm.key)"
                  (change)="togglePermission(selectedRole, perm.key)"
                  [disabled]="saving || !canEdit"
                  color="primary">
                </mat-slide-toggle>
                <div class="permission-info">
                  <span class="permission-label">{{ perm.label }}</span>
                  <span class="permission-desc">{{ perm.description }}</span>
                </div>
              </div>
            </div>
          </div>
        </mat-card-content>
        <mat-card-actions align="end" *ngIf="canEdit">
          <button mat-flat-button color="primary" type="button"
            [disabled]="!dirty || saving"
            (click)="savePermissions()">
            {{ saving ? 'Saving...' : 'Save Changes' }}
          </button>
        </mat-card-actions>
      </mat-card>
    </div>

    <!-- Empty state when no role selected (desktop only) -->
    <div class="permission-panel permission-panel--empty" *ngIf="!selectedRole">
      <mat-card class="permission-panel-card empty-state-card">
        <mat-card-content>
          <div class="empty-state">
            <mat-icon>security</mat-icon>
            <h3>Select a role</h3>
            <p>Choose a role from the list to view and manage its permissions.</p>
          </div>
        </mat-card-content>
      </mat-card>
    </div>

  </div>

</app-configuration-page>
